import { Store } from "Application/Store/Store";
import { ihm_viewer__dictionary, locale } from "Application/i18n/i18nViewer";
import { SET_POPUP, CLEAR_POPUP } from "Application/Store/Actions/HistoryTypes";
import { POPUP_TYPES } from "Application/Store/Actions/HistoryTypes";
import { EditorManager } from "Domain/Scene/Manager/EditorManager";
import { hasAnyToothBeenModified } from "Domain/Mesh/Handler/MeshSelectorEvent";
import { sceneTransition } from 'Domain/Scene/Utils/SceneTransition';

const dispatch = () => Store.dispatch;

const openProgressPopup = (type, message) => {
    dispatch()({
        type: SET_POPUP,
        payload: {
            type,
            message
        }
    });
};

/**
 * Popup de sauvegarde (non-bloquant)
 */
export const savingPopup = () => {
    openProgressPopup(
        POPUP_TYPES.SAVING,
        ihm_viewer__dictionary.SAVING?.[locale()] || 'Sauvegarde en cours ...'
    );
};

export const deletingPopup = () => {
    openProgressPopup(
        POPUP_TYPES.SAVING,
        ihm_viewer__dictionary.DELETING?.[locale()] || 'Suppression en cours ...'
    );
};

/**
 * Popup d'enregistrement terminé
 */
export const savedPopup = () => {
    dispatch()({ type: CLEAR_POPUP });
};

/**
 * Confirmation pour quitter le mode édition
 */
export const confirmLeaveEditMode = (dispatch, setOnEditMode) => {
    dispatch({
        type: SET_POPUP,
        payload: {
            type: POPUP_TYPES.CONFIRM_LEAVE_EDIT_MODE,
            message: ihm_viewer__dictionary.SAVE_VERSION?.[locale()] || 'Voulez-vous enregistrer les modifications ?',
            onConfirm: () => sceneTransition(() => EditorManager.exitEditMode(setOnEditMode, true)),
            confirmText: ihm_viewer__dictionary.YES?.[locale()] || 'Oui',
            cancelText: ihm_viewer__dictionary.NO?.[locale()] || 'Non'
        }
    });
};

/**
 * Confirmation pour supprimer la version
 */
export const confirmDeleteVersion = (dispatch, setOnEditMode) => {
    dispatch({
        type: SET_POPUP,
        payload: {
            type: POPUP_TYPES.CONFIRM_DELETE_VERSION,
            message: ihm_viewer__dictionary.CONFIRM_DELETE_VERSION?.[locale()] || 'Êtes-vous sûr de vouloir supprimer cette version ?',
            onConfirm: () => EditorManager.deleteCurrentVersion(),
            confirmText: ihm_viewer__dictionary.YES?.[locale()] || 'Oui',
            cancelText: ihm_viewer__dictionary.NO?.[locale()] || 'Non'
        }
    });
};

/**
 * Confirmation pour annuler les modifications
 */
export const confirmCancelChanges = (dispatch, setOnEditMode) => {
    if (!hasAnyToothBeenModified()) {
        sceneTransition(() => EditorManager.exitEditMode(setOnEditMode, false));
        return;
    }
    dispatch({
        type: SET_POPUP,
        payload: {
            type: POPUP_TYPES.CONFIRM_CANCEL_CHANGES,
            message: ihm_viewer__dictionary.CONFIRM_CANCEL_CHANGES?.[locale()] || 'Voulez-vous annuler les modifications ?',
            onConfirm: () => sceneTransition(() => EditorManager.exitEditMode(setOnEditMode, false)),
            confirmText: ihm_viewer__dictionary.YES?.[locale()] || 'Oui',
            cancelText: ihm_viewer__dictionary.NO?.[locale()] || 'Non'
        }
    });
};

/**
 * Ouvre une popup personnalisée
 */
export const openCustomPopup = (dispatch, { title, content, size = 'medium' }) => {
    dispatch({
        type: SET_POPUP,
        payload: {
            type: POPUP_TYPES.CUSTOM,
            title,
            content,
            size
        }
    });
};
